import { render, staticRenderFns } from "./ProdSquareSku.vue?vue&type=template&id=2fb9948c&"
import script from "./ProdSquareSku.vue?vue&type=script&lang=js&"
export * from "./ProdSquareSku.vue?vue&type=script&lang=js&"
import style0 from "./ProdSquareSku.vue?vue&type=style&index=0&id=2fb9948c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports